import React, { useEffect, useState } from 'react'
import ApplicationHeader from '../../../agent/lead/Application/ApplicationHeader'
import Tabs from "../../../agent/lead/Application/Tabs"
import { useDispatch, useSelector } from 'react-redux'
import { fetchLeads } from "../../../../redux/features/adminLeadSlice";
import { useParams } from 'react-router-dom'
import AgentApplicationForm from '../../../agent/lead/Application/AgentApplicationForm'
import apiFetch from '../../../../utlis/apiFetch';


const MainApplication = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const { leads, isLoading, error } = useSelector((state) => state.leads);
  const [selectedData, setSelectedData] = useState(null)
  const [isFetchingById, setIsFetchingById] = useState(false)
  const [fetchByIdError, setFetchByIdError] = useState(null)

  useEffect(() => {
    let isMounted = true

    const fetchLeadById = async () => {
      try {
        setIsFetchingById(true)
        setFetchByIdError(null)

        const token = localStorage.getItem('token')
        if (!token) throw new Error('No authentication token found')

        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/application/getApplication/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        })

        const data = response._data ?? await response.json()
        if (!response.ok) throw new Error(data?.message || 'Failed to fetch application')

        const fetchedApplication = data?.body || data?.application || data

        if (isMounted) {
          setSelectedData({ ...fetchedApplication })
        }

        // Keep lead list in sync for other screens.
        dispatch(fetchLeads())
      } catch (err) {
        console.error('Failed to fetch lead by id:', err)
        const fallbackLead = leads.find((lead) => lead._id === id)

        if (isMounted && fallbackLead) {
          setSelectedData({ ...fallbackLead })
          setFetchByIdError(null)
        } else if (isMounted) {
          setFetchByIdError(err.message || 'Failed to fetch application')
        }
      } finally {
        if (isMounted) setIsFetchingById(false)
      }
    }

    if (id) {
      fetchLeadById()
    }

    return () => {
      isMounted = false
    }
  }, [id, dispatch])

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  const handleRefresh = (freshData) => {
    if (freshData?._id) {
      setSelectedData({ ...freshData })
    }
  }

  if (isLoading || isFetchingById) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="w-8 h-8 border-4 border-blue-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className='md:p-4 md:space-y-5 text-sm md:text-base'>
      {selectedData &&
        <>
          <ApplicationHeader selectedData={selectedData} />
          <AgentApplicationForm selectedData={selectedData} />
          <Tabs selectedData={selectedData} onRefresh={handleRefresh} forceChecklistRefresh={true} />
        </>
      }
      {fetchByIdError && !selectedData && <p className='text-red-500 text-center text-sm mt-6'>{fetchByIdError}</p>}
    </div>
  )
}

export default MainApplication